(function(_s) {
    const SPLIDE_CDN_URL = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

    // Debounce function implementation
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Native script loader to replace fetchInject
    function loadScript(src) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
            document.head.appendChild(script);
        });
    }

    _s.fn.relatedArticlesInit = function() {
        return this.each(el => {
            const _self = _s(el);

            const defaultConfig = {
                type: 'slide',
                perPage: 3,
                perMove: 1,
                gap: '1rem',
                arrows: true,
                pagination: false,
                refreshOnResize: true,
                draggable: true,
                emitEvents: ['moved', 'active'],
                breakpoints: {
                    1024: { 
                        perPage: 2,
                        perMove: 1
                    },
                    640: { 
                        perPage: 1,
                        perMove: 1
                    }
                }
            };

            const customConfig = JSON.parse(_self.attr('data-splide') || '{}');
            const config = { ...defaultConfig, ...customConfig };

            const slideCount = _self.find('.splide__slide').length;
            config.arrows = slideCount > 1;
            config.pagination = false; // Related articles: arrows only, no nav dots
            config.drag = slideCount > 1;

            const splideInstance = new Splide(el, config);

            splideInstance.on('mounted', () => {
                _self.addClass('is-initialized');
                console.log('✅ Related Articles Splide initialized');
            });

            splideInstance.mount();

            if (config.refreshOnResize) {
                _s(window).on('resize', debounce(() => {
                    splideInstance.refresh();
                }, 100));
            }

            if (config.emitEvents) {
                config.emitEvents.forEach(evName => {
                    splideInstance.on(evName, (a, b, c) => {
                        _self.trigger(`sp-splide-${evName}`, {
                            newIndex: a,
                            prevIndex: b,
                            destIndex: c,
                        });
                    });
                });
            }
        });
    };

    _s(document).ready(() => {
        const _elements = _s('.related-articles-slider');
        if (_elements.el.length) {
            loadScript(SPLIDE_CDN_URL)
                .then(() => {
                    _elements.relatedArticlesInit();
                })
                .catch(error => {
                    console.error('Failed to load Splide library:', error);
                });
        }
    });
})(window._s);

export default function() {
    // This function can be called if needed for manual initialization
    if (window._s) {
        const _elements = window._s('.related-articles-slider');
        if (_elements.el.length) {
            _elements.relatedArticlesInit();
        }
    }
}